import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { apiFetch } from "../../api.js";
import Select from "react-select";

const HpnLetterDetailsDesign = () => {
  const navigate = useNavigate();
  const routerLocation = useLocation();

  const [FromDate, setFromDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });

  // still keeping your variable name (no breaking styles or logic)
  const [CustomerName, setCustomerName] = useState("");
  const [CustomerNameList, setCustomerNameList] = useState([]);

  const [Address, setAddress] = useState("");
  const [HpnId, setHpnId] = useState("");
  const [ModelId, setModelId] = useState("");
  const [VariantId, setVariantId] = useState("");

  const [Hpn, setHpn] = useState(""); // for display
  const [Model, setModel] = useState("");
  const [Variant, setVariant] = useState("");

  const [gridData, setGridData] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [serverIp] = useState(window.location.hostname);
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "40px",
      height: "40px",
      borderRadius: "5px",
      borderColor: "#ccc",
      boxShadow: "none",
      fontSize: "14px",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "40px",
      padding: "0 10px",
      display: "flex",
      alignItems: "center",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "40px",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };
  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);
  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async (search = "") => {
    try {
      const response = await apiFetch(
        "/api/hpn/customer",
        { method: "POST", body: JSON.stringify({ search }) },
      );
      const data = await response.json();
      const list = data?.list || [];

      setCustomerNameList(
        list.map((item) => ({
          label: String(item.value || ""),
          value: String(item.data || ""),
        })),
      );
    } catch (err) {
      console.error("Customer fetch failed", err);
    }
  };

  const fetchDetails = async (customerId) => {
    try {
      const response = await apiFetch(
        "/api/hpn/details",
        { method: "POST", body: JSON.stringify({ customerId }) },
      );
      const data = await response.json();
      if (data?.data?.length) {
        const d = data.data[0];
        setAddress(d.city || "");
        setHpn(d.hpn || "");
        setHpnId(d.sp_471 || d.sp_523 || "");
        setModel(d.sp_524 || "");
        setModelId(d.sp_470 || "");
        setVariant(d.variant || "");
        setVariantId(d.sp_471 || "");
      }
    } catch (err) {
      console.error("Details fetch failed", err);
    }
  };

  const fetchGrid = async (customerId) => {
    try {
      const response = await apiFetch(
        "/api/hpn/grid",
        { method: "POST", body: JSON.stringify({ customerId }) },
      );
      const data = await response.json();
      setGridData(data?.list || []);
    } catch (err) {
      console.error("Grid load failed", err);
    }
  };

  const handleSave = async () => {
    try {
      if (!CustomerName) {
        alert("Select customer first");
        return;
      }

      const payload = {
        entryDate: FromDate,
        customerName: CustomerName,

        hpn: HpnId,
        model: ModelId,
        variant: VariantId,

        userId: storedUserInfo?.userid || "",
        ipAddress: ipAddress,
        serverIp: serverIp,
      };
      console.log(payload);
      const response = await apiFetch(
        "/api/hpn/savedata",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const data = await response.json();
      if (data.err === "0") {
        alert("Saved successfully");
        const pdfRes = await apiFetch(
          "/api/hpn/letter-print",
          {
            method: "POST",
            body: JSON.stringify({ customerId: data.unqid }),
          },
        );
        const blob = await pdfRes.blob();
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
      } else {
        alert(data.msg || "Save failed");
      }
    } catch (err) {
      console.error(err);
      alert("Save error");
    }
  };

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">HPN Letter</div>

          {/* -------- ROW 1 -------- */}
          <div className="form-row">
            <div className="form-column">
              <label>DATE</label>
              <input
                type="date"
                value={FromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="form-column">
              <label>Customer Name</label>
              <Select
                options={CustomerNameList}
                value={
                  CustomerNameList.find((o) => o.value === CustomerName) || null
                }
                styles={customSelectStyles}
                placeholder="Select Customer Name"
                isSearchable
                onInputChange={(value, { action }) => {
                  if (action === "input-change") {
                    fetchCustomers(value || "");
                  }
                }}
                onChange={(selected) => {
                  setCustomerName(selected.value);
                  fetchDetails(selected.value);
                  fetchGrid(selected.value);
                }}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div className="form-column">
              <label>Address</label>
              <input type="text" value={Address} disabled />
            </div>

            <div className="form-column">
              <label>Hpn</label>
              <input type="text" value={Hpn} disabled />
            </div>
          </div>

          {/* -------- ROW 2 -------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Model</label>
              <input type="text" value={Model} disabled />
            </div>

            <div className="form-column">
              <label>Variant</label>
              <input type="text" value={Variant} disabled />
            </div>
          </div>

          {/* -------- TABLE -------- */}
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>RNo</th>
                  <th>Date</th>
                  <th>Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {gridData.length === 0 ? (
                  <tr>
                    <td colSpan="5">No records found</td>
                  </tr>
                ) : (
                  gridData.map((row, i) => (
                    <tr key={i}>
                      <td>{row.rcl_9}</td>
                      <td>{row.to_char}</td>
                      <td>{row.rcl_58}</td>
                      <td>{row.mode1}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* -------- BUTTONS -------- */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "14px",
              marginTop: "30px",
            }}
          >
            {!isEditing && (
              <button
                style={{
                  background: "#4caf50",
                  color: "#fff",
                  padding: "12px 28px",
                  borderRadius: "6px",
                  border: "none",
                }}
                onClick={handleSave}
              >
                Save
              </button>
            )}

            <button
              style={{
                background: "#ab2025",
                color: "#fff",
                padding: "12px 28px",
                borderRadius: "6px",
                border: "none",
              }}
            >
              Exit
            </button>
          </div>
        </div>
      </div>

      {/* 🔥 YOUR STYLE BLOCK REMAINS EXACTLY AS IT WAS */}
      <style>
        {`
      .rs__menu-portal {
  z-index: 9999 !important;
}

/* ===== PAGE ===== */
.page-container {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 12px;
}

.container {
  width: 100%;
  max-width: 100%;
  background: #fff;
  border-radius: 8px;
  padding: 18px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.08);
}

/* ===== HEADER ===== */
.header {
  text-align: center;
  font-size: 1.6rem;
  font-weight: 700;
  padding: 14px;
  background: linear-gradient(90deg, #8B1E3F, #8B1E3F);
  color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}

/* ===== FORM GRID ===== */
.form-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 15px;
  margin-bottom: 15px;
}

.form-column {
  display: flex;
  flex-direction: column;
}

label {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}

/* Inputs + react-select look same */
input,
select {
  height: 40px !important;
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  background: #fff;
  box-sizing: border-box;
}

/* ===== TABLE ===== */
.table-container {
  overflow-x: auto;
  margin-top: 20px;
  border: 1px solid #ddd;
  border-radius: 6px;
}

table {
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  table-layout: fixed;
}

th {
  background: #f8bcbc;
  padding: 10px;
  border: 1px solid #ccc;
  text-align: center;
  white-space: nowrap;
  position: sticky;
  top: 0;
}

td {
  border: 1px solid #ccc;
  padding: 6px;
  min-width: 110px;
  text-align: center;
}

/* Grid inputs */
.grid-input {
  width: 100%;
  height: 32px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  text-align: center;
}

.grid-input:focus {
  outline: none;
  background: #fff3cd;
}

/* Delete button (clean) */
.delete-btn {
  background: #d32f2f;
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

/* ===== BUTTONS ===== */
.button-container {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 22px;
  flex-wrap: wrap;
}

.btn-save {
  background: #4caf50;
  color: #fff;
  padding: 12px 28px;
  border-radius: 6px;
  border: none;
  font-weight: 600;
  cursor: pointer;
}

.btn-exit {
  background: #ab2025;
  color: #fff;
  padding: 12px 28px;
  border-radius: 6px;
  border: none;
  font-weight: 600;
  cursor: pointer;
}

/* ===== RESPONSIVE ===== */

/* Laptop */
@media (max-width: 1200px) {
  .form-row {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Tablet */
@media (max-width: 992px) {
  .form-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile */
@media (max-width: 480px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }

  .button-container {
    flex-direction: row;
  }

  .button-container button {
    flex: 1;
  }
}

`}
      </style>
    </Layout>
  );
};

export default HpnLetterDetailsDesign;
